// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const IllustratorExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect width={36} height={36} rx={8} fill="#DD8716" />
				<g opacity={0.9}>
					<path
						d="M10.5078 24L14.4141 12.6875H17.4297L21.3438 24H18.8203L15.9688 15.2422H15.875L13.0156 24H10.5078ZM18.9297 19.5547V21.3906H12.8906V19.5547H18.9297Z"
						fill="white"
					/>
					<path
						d="M22.6172 15.5156H24.9297V24H22.6172V15.5156ZM23.7734 14.3984C23.5391 14.3984 23.3255 14.3464 23.1328 14.2422C22.9453 14.1328 22.7943 13.9896 22.6797 13.8125C22.5651 13.6354 22.5078 13.4401 22.5078 13.2266C22.5078 13.0182 22.5651 12.8229 22.6797 12.6406C22.7943 12.4583 22.9479 12.3151 23.1406 12.2109C23.3333 12.1068 23.5443 12.0547 23.7734 12.0547C23.9974 12.0547 24.2057 12.1068 24.3984 12.2109C24.5911 12.3151 24.7448 12.4583 24.8594 12.6406C24.974 12.8229 25.0312 13.0182 25.0312 13.2266C25.0312 13.4401 24.974 13.6354 24.8594 13.8125C24.7448 13.9896 24.5911 14.1328 24.3984 14.2422C24.2057 14.3464 23.9974 14.3984 23.7734 14.3984Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
IllustratorExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default IllustratorExtension;
